import { Carousel } from '@mantine/carousel';
import { DirectionProvider, MantineProvider } from '@mantine/core';
import { IconChevronLeft } from '@tabler/icons-react';
import Autoplay from 'embla-carousel-autoplay';
import type { FC } from 'react';
import { useRef } from 'react';
import { Container } from '@/DesignSystem/Component';
import SubscriptionComment from '@/Module/Subscription/Component/SubscriptionCommentSlider/SubscriptionComment';
import styles from './SubscriptionCommentSlider.module.scss';
export interface ISubscriptionComment {
  id: number;
  rating: number;
  comment: string;
  name: string;
  grade: string;
  img: string;
}
const data: ISubscriptionComment[] = [{
  id: 1,
  rating: 5,
  name: 'سارا ملکی',
  comment: 'آزمون ریاضی برام کابوس بود! ولی ویدیوهای آی‌نو مثل نینجا نکات رو زد وسط هدف! نمره‌م شد ۱۹.۵ 👊🏼',
  grade: 'پایه هشتم',
  img: 'person1'
}, {
  id: 2,
  rating: 5,
  name: 'مهدی صادقی',
  comment: 'فقط با ویدیوهای آی‌نو و تست‌های پرتکرارش، تونستم همه فصل‌ها رو تو ۳ روز جمع کنم. نجات‌دهنده‌ی شب امتحان!',
  grade: 'پایه یازدهم تجربی',
  img: 'person3'
}, {
  id: 3,
  rating: 4,
  name: 'الناز رمضانی',
  comment: 'سوالات شبیه‌سازی آزمون تیزهوشان آی‌نو خیلی کمکم کرد تا بتونم با اعتمادبه‌نفس تو آزمون اصلی حاضر بشم!',
  grade: 'داوطلب تیزهوشان',
  img: 'person2'
}, {
  id: 4,
  rating: 5,
  name: 'م کریمی',
  comment: 'هر بار شب امتحان استرس داشتیم، ولی الان با آی‌نو بچه‌م با یه برنامه مشخص جلو می‌ره. واقعاً آرامش گرفتیم.',
  grade: 'مادرِ دانش‌آموز',
  img: 'person4'
}, {
  id: 5,
  rating: 5,
  name: 'سارا ملکی',
  comment: 'آزمون ریاضی برام کابوس بود! ولی ویدیوهای آی‌نو مثل نینجا نکات رو زد وسط هدف! نمره‌م شد ۱۹.۵ 👊🏼',
  grade: 'پایه هشتم',
  img: 'person2'
}];
const SubscriptionCommentSlider: FC = () => {
  const autoPlay = useRef(Autoplay({
    delay: 10000,
    stopOnMouseEnter: true,
    stopOnInteraction: true
  }));
  return <div className="bg-[#b5ccf1]/25" data-sentry-component="SubscriptionCommentSlider" data-sentry-source-file="SubscriptionCommentSlider.tsx">
      <Container className="max-w-[1360px]" data-sentry-element="Container" data-sentry-source-file="SubscriptionCommentSlider.tsx">
        <h3 className="text-blackfive pt-6 text-center text-xl font-semibold sm:pt-10"> صدای شما، قدرت ماست!</h3>
        <DirectionProvider initialDirection="rtl" data-sentry-element="DirectionProvider" data-sentry-source-file="SubscriptionCommentSlider.tsx">
          <MantineProvider data-sentry-element="MantineProvider" data-sentry-source-file="SubscriptionCommentSlider.tsx">
            <Carousel classNames={styles} withIndicators slideSize={{
            base: '100%',
            sm: '50%',
            md: '33.333333%',
            xl: '25%'
          }} slidesToScroll={1} height="auto" plugins={[autoPlay.current]} slideGap={{
            base: 0,
            md: '15px',
            lg: '15px'
          }} loop previousControlIcon={<IconChevronLeft size="small" className=" h-8 w-8 rotate-180 text-blueFour" />} nextControlIcon={<IconChevronLeft size="small" className="h-8 w-8  text-blueFour" />} align="end" dragFree data-sentry-element="Carousel" data-sentry-source-file="SubscriptionCommentSlider.tsx">
              {data.map(slider => <Carousel.Slide key={slider.id}>
                  <SubscriptionComment {...slider} />
                </Carousel.Slide>)}
            </Carousel>
          </MantineProvider>
        </DirectionProvider>
      </Container>
    </div>;
};
export default SubscriptionCommentSlider;